import { render, staticRenderFns } from "./SectionActionUser.vue?vue&type=template&id=764edcc0&"
import script from "./SectionActionUser.vue?vue&type=script&lang=js&"
export * from "./SectionActionUser.vue?vue&type=script&lang=js&"
import style0 from "./SectionActionUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports